import { ICongThucTinhDiem } from "../../../model/response/category/ICongThucTinhDiem";
import { ILopTinChiViewModel } from "../../../model/response/tkb/ILopTinChiViewModel";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eCongThucTinhDiemActionObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICongThucTinhDiem[], 
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ICongThucTinhDiem | undefined, 
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ICongThucTinhDiem, 
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[],

    CHANGE_FILTER: {} as { id_he: number },

    CHANGE_CONG_THUC_LOP_HOC_PHAN_MODAL: {} as { ky_dang_ky?: number, nam_hoc?: string, hoc_ky?: number, isShowModal?: boolean, status?: eReducerStatusBase },

    LOAD_LOP_TIN_CHI_START: {} as { ky_dang_ky: number },
    LOAD_LOP_TIN_CHI_SUCCESS: {} as ILopTinChiViewModel[],
    LOAD_LOP_TIN_CHI_ERROR: "",

    SAVE_CONG_THUC_LOP_HOC_PHAN_START: {} as { ky_dang_ky: number, id_lop_tcs: number[] },
    SAVE_CONG_THUC_LOP_HOC_PHAN_SUCCESS: undefined,
    SAVE_CONG_THUC_LOP_HOC_PHAN_ERROR: "",
};
export const eCongThucTinhDiemActionIds = generateActionTypeIds(eCongThucTinhDiemActionObj, "CONG_THUC_TINH_DIEM");
export type ICongThucTinhDiemActionTypes = IGenericActionType<typeof eCongThucTinhDiemActionObj, "CONG_THUC_TINH_DIEM">;